import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SfaDealContainerModel } from "../../../../../../models/aggregates/sfa/deal/SfaDealContainer.model";
import { ApiVisa, BasicApiResponseModel } from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
    providedIn: 'root'
    })
    export class SfaDealService extends BaseApiTemplateService<SfaDealContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deals';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deals';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deals';
        this.httpClient = http;
    }

    uploadFile(formData: FormData, dealGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
        let url = this.apiUrl + "/file/" + dealGuid + "/upload";
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + "/file/" + dealGuid + "/upload";
        }
        return this.httpClient.post<BasicApiResponseModel<any>>(
          url,
          formData,
          this.getHttpHeader(visa)
        );
      }
      
      getFile(dealGuid: string, visa: ApiVisa): Observable<Blob> {
        let url = this.apiUrl + '/file/' + dealGuid;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/file/' + dealGuid;
        }
        return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
      }

      // getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
      //   let url = this.apiUrl + '/file/' + extGuid;
      //   if (this.endpoint_path && visa.api_domain_url) {
      //     url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
      //   }
      //   return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
      // }
    }